import { data } from "../constants/data";
const CertificatesCard = ({ data }) => {
  return (
    <>
      <div className="gap-2 max-w-4xl flex gap-2 justify-between m-auto border border-gray-200 dark:border-gray-800 rounded px-4 hover:shadow hover:border hover:border-gray-300 dark:hover:border dark:hover:border-sky-500">
        <div>
          <img src={data.img} className="object-scale-down h-48  mb-10" />
        </div>
        <div>
          <p className="font-bold text-cyan-600 text-xl mt-20">{data.name}</p>
          <a
            className="text-white rounded-full px-2 py-1 bg-blue-600 text-xs font-semibold"
            href={data.verification}
          >
            Verify
          </a>
        </div>

        {/* <div className="flex flex-wrap justify-between mt-10">
          <p className="text-md text-gray-800 font-bold dark:text-gray-600">
            {data?.designation}
          </p>
          <p className="text-xs text-gray-800 font-bold dark:text-gray-600 mt-1 italic">
            {data?.duration}
          </p>
        </div> */}

        {/* <ul className="ml-4 text-sm  text-gray-800 dark:text-gray-300 list-disc">
          {data?.works?.map((exp) => {
            return <li className="leading-relaxed">{exp}</li>;
          })}
        </ul> */}
      </div>
    </>
  );
};
export const Certificates = () => {
  return (
    <>
      {data.certificates.map((dt) => {
        return <CertificatesCard data={dt} />;
      })}
    </>
  );
};
